import { useAppSelector } from '../redux/hooks';
import { PermissionService } from '../services/permission.service';
import { AccountRoles } from '../types/enums/accountRoles.enum';
import { AppRoles } from '../types/enums/appRoles.enum';

/**
 * Account owners and account admins can change existing payout details (identity and bank account)
 * and see the saved details. Other roles can only complete first-time setup and upload requested documents.
 */
const useCanManagePayouts = (): boolean => {
  const accountRoles = useAppSelector(state => state.auth.accountContext.roles) as AccountRoles[];
  const appRoles = useAppSelector(state => state.auth.appContext.roles) as AppRoles[];
  const enabled = useAppSelector(state => state.user.enabled);
  const verified = useAppSelector(state => state.user.verified);

  return new PermissionService(accountRoles, appRoles, enabled, verified).userHasSettingsPermission();
};

export default useCanManagePayouts;
